import { gql } from '@apollo/client';

export const GET_VAT_CONFIGURATION = gql`
    query GetVATConfiguration {
        vatConfiguration {
            id
            organizationId
            vatPercentage
            vatType
            displayVatSeparately
            effectiveDate
            previousVatPercentage
            previousVatType
            changeReason
            isActive
            createdAt
            updatedAt
            createdBy
            updatedBy
        }
    }
`;

export const GET_VAT_CONFIGURATION_HISTORY = gql`
    query GetVATConfigurationHistory($limit: Int = 10) {
        vatConfigurationHistory(limit: $limit) {
            id
            organizationId
            vatPercentage
            vatType
            displayVatSeparately
            effectiveDate
            previousVatPercentage
            previousVatType
            changeReason
            isActive
            createdAt
            updatedAt
            createdBy
            updatedBy
        }
    }
`;

export const CALCULATE_VAT = gql`
    query CalculateVAT($input: VATCalculationInput!) {
        calculateVAT(input: $input) {
            exclusiveAmount
            vatAmount
            inclusiveAmount
            vatPercentage
            vatType
        }
    }
`;

export const UPDATE_VAT_CONFIGURATION = gql`
    mutation UpdateVATConfiguration($input: UpdateVATConfigurationInput!) {
        updateVATConfiguration(input: $input) {
            id
            organizationId
            vatPercentage
            vatType
            displayVatSeparately
            effectiveDate
            previousVatPercentage
            previousVatType
            changeReason
            isActive
            createdAt
            updatedAt
            createdBy
            updatedBy
        }
    }
`;

export const CREATE_DEFAULT_VAT_CONFIGURATION = gql`
    mutation CreateDefaultVATConfiguration {
        createDefaultVATConfiguration {
            id
            organizationId
            vatPercentage
            vatType
            displayVatSeparately
            effectiveDate
            changeReason
            isActive
            createdAt
            updatedAt
            createdBy
            updatedBy
        }
    }
`;